import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useFilters } from '../../context/FilterContext';
import { useResponsive } from '../../hooks/useResponsive';
import DateRangeFilter from './DateRangeFilter';
import DayOfWeekFilter from './DayOfWeekFilter';
import TimeFilter from './TimeFilter';
import DiningBehaviorFilter from './DiningBehaviorFilter';

import './FilterPanel.css';

const FilterPanel: React.FC = () => {
  const { t } = useTranslation();
  const { resetFilters } = useFilters();
  const { isLaptop, isiPad, isiPhone } = useResponsive();

  const handleResetFilters = () => {
    resetFilters();
  };
  
  
  useEffect(() => {
    if (!isiPhone && !isiPad) return;
    
    const handleFilterClick = (event: Event) => {
      const target = event.target as HTMLElement;
      const isFilterButton = target.closest('.filter-button, .date-filter-button, .day-filter-button, .time-filter-button, .dining-behavior-button');
      const isDropdownContent = target.closest('.date-picker-dropdown, .day-picker-dropdown, .time-picker-dropdown, .dining-picker-dropdown');
      
      if (!isFilterButton && !isDropdownContent) {
        
        const allDropdowns = document.querySelectorAll('.date-picker-dropdown, .day-picker-dropdown, .time-picker-dropdown, .dining-picker-dropdown');
        allDropdowns.forEach(dropdown => {
          const parent = dropdown.parentElement;
          if (parent) {
            const button = parent.querySelector('.filter-button, .date-filter-button, .day-filter-button, .time-filter-button, .dining-behavior-button') as HTMLElement;
            if (button) {
              button.click(); 
            }
          }
        });
      } else if (isFilterButton) {
        
        const allDropdowns = document.querySelectorAll('.date-picker-dropdown, .day-picker-dropdown, .time-picker-dropdown, .dining-picker-dropdown');
        const currentFilterParent = isFilterButton.closest('.date-range-filter, .day-of-week-filter, .time-filter, .dining-behavior-filter');
        
        allDropdowns.forEach(dropdown => {
          const parent = dropdown.parentElement;
          if (parent && parent !== currentFilterParent) {
            const button = parent.querySelector('.filter-button, .date-filter-button, .day-filter-button, .time-filter-button, .dining-behavior-button') as HTMLElement;
            if (button) {
              
              const dropdownElement = parent.querySelector('.date-picker-dropdown, .day-picker-dropdown, .time-picker-dropdown, .dining-picker-dropdown');
              if (dropdownElement && window.getComputedStyle(dropdownElement).display !== 'none') {
                button.click(); 
              }
            }
          }
        });
      }
    };
    
    document.addEventListener('click', handleFilterClick);
    return () => {
      document.removeEventListener('click', handleFilterClick);
    };
  }, [isiPhone, isiPad]);

  return (
    <div className="filter-panel">
      <div className="filter-title-band">
        <h3 style={{
          fontSize: isLaptop ? '16px' : '18px',
          padding: isLaptop ? '8px 20px' : '10px 25px'
        }}>
          {t('filter.title')}
        </h3>
      </div>
      
      <div className="filter-panel-container">
        <button 
          className="reset-filters-button"
          onClick={handleResetFilters}
          style={{
            fontSize: isLaptop ? '11px' : '13px',
            padding: isLaptop ? '4px 12px' : '5px 15px'
          }}
        >
          {t('filter.reset')}
        </button>
        
        <div className="filter-panel-content">
          <div className="filter-section">
            <div className="filter-controls">
              <DateRangeFilter />
              <DayOfWeekFilter />
              <TimeFilter />
              <DiningBehaviorFilter />
              
              {}
              {}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FilterPanel;